
module dg.actions {
    import IQueryAction = dg.domain.queries.IQueryAction;
    import ListQueryResult = dg.domain.queries.ListQueryResult;

    export abstract class QueryManipulator {

        public readonly sortable: boolean;
        public readonly pageable: boolean;
        protected readonly patternSearchable: boolean;

        protected resultLoadedFirstTimeDefered: ng.IDeferred<any>;
        public dataLoaded: boolean = true;

        private lastExecutedQuery: IQueryAction;
        private originalQuery: IQueryAction;

        private get sortableQuery(): dg.domain.actions.ISortable {
            return <any>this._query;
        }

        private get pageableQuery(): dg.domain.actions.IPageable {
            return <any>this._query;
        }


        private readonly RESULT_CHANGED = 'RESULT_CHANGED';
        private readonly START_EXECUTING_QUERY = 'START_EXECUTING_QUERY';

        protected listPagingOptions: dg.lists.IListPagingOptions;

        //protected queryResult: ListQueryResult<dg.domain.IDomainObject>;
        protected queryResult: any;

        constructor(
            protected $scope: ng.IScope,
            protected $q: ng.IQService,
            protected _query: IQueryAction) {

            this.resultLoadedFirstTimeDefered = this.$q.defer();

            this.sortable = !!this.sortableQuery.sortFields;
            if (this.sortable) {
                if (!this.sortableQuery.sortCriteria) {
                    this.sortableQuery.sortCriteria = [{
                        property: '',
                        direction: '',
                        displayValue: ''
                    }];
                }
            }
            else {
                this.sortableQuery.sortFields = [];
                this.sortableQuery.sortCriteria = [];
            }

            this.pageable = !!this.pageableQuery.pageNumber;
            if (this.pageable) {
                this.listPagingOptions = {
                    pageNumber: this.pageableQuery.pageNumber || 1,
                    pageSize: this.pageableQuery.pageSize,
                    pageStep: 1
                };
            }

            this.patternSearchable = this._query.dgMeta ? !!this._query.dgMeta.properties.pattern : false;

            this.cloneQuery();
            this.originalQuery = angular.copy(this.query);
        }

        public get totalItemsCount(): number {
            return this.queryResult.totalCount;
        }

        public get sortCriteria() {
            return this.sortableQuery.sortCriteria[0];
        }

        public get sortFields() {
            return this.sortableQuery.sortFields;
        }

        public get pageNumber() {
            return this.pageableQuery.pageNumber;
        }

        public get query() {
            return this._query;
        }


        public get result() {
            return this.queryResult;
        }

        public get pagingOptions() {
            return this.listPagingOptions;
        }


        public revertQuery() {
            this._query = angular.copy(this.lastExecutedQuery);
        }
        public onResultChanged(handler) {
            return this.$scope.$on(this.RESULT_CHANGED, (event, message) => {
                handler();
            });
        }

        public onStartExecutingQuery(handler) {
            return this.$scope.$on(this.START_EXECUTING_QUERY, (event, message) => {
                handler(this.query);
            });
        }

        public onResultLoadedFirstTime(handler) {
            this.resultLoadedFirstTimeDefered.promise.then(() => {
                handler();
            }, angular.noop);
        }

        public sort(sortCriteria: dg.domain.queries.SortCriterion) {

            if (!this.sortable) {
                throw new Error("The query doesn't support soring");
            }

            //HACK :support only one sort criterion
            this.sortableQuery.sortCriteria[0] = dgUtils.ObjectHelperService.mergeDeep(this.sortableQuery.sortCriteria[0], sortCriteria);

            this.resetPaging();

            this.executeQuery();
        }

        public changePage(listPagingOptions: dg.lists.IListPagingOptions) {

            if (!this.pageable) {
                throw new Error("The query doesn't support paging");
            }

            this.pageableQuery.pageNumber = listPagingOptions.pageNumber;
            this.pageableQuery.pageSize = listPagingOptions.pageSize;

            this.executeQuery();
        }

        public resetPaging = () => {
            if (this.pageable) {
                this.pageableQuery.pageNumber = 1;
            }

            //this.$scope.$broadcast(this.PAGING_RESETTED, {});
        }

        public hasNextPage = () => {

            return !(this.pagingOptions.pageNumber >= (this.pagingOptions.totalCount / this.pagingOptions.pageSize))
        }


        public resetQuery() {
            this._query = angular.copy(this.originalQuery);
        }



        public executeQuery = () => {
            this.$scope.$broadcast(this.START_EXECUTING_QUERY, {});
            this.dataLoaded = true;
            //this.resultChange();

            if (this._query) {
                this.cloneQuery();
                this.dataLoaded = false;

                this.getData().then((resultData) => {
                    this.queryResult = resultData;
                    this.updatePagingOptions(this.queryResult.totalCount);

                    this.resultLoadedFirstTimeDefered.resolve();
                    this.resultChange();

                    this.dataLoaded = true;
                }, angular.noop);
            } else {
                throw new Error('Query is not defined');
            }
        }

        protected abstract getData(): ng.IPromise<any>;

        cloneQuery() {
            this.lastExecutedQuery = angular.copy(this.query);
        }

        private resultChange() {
            this.$scope.$broadcast(this.RESULT_CHANGED, {});
        }

        private updatePagingOptions(totalCount) {
            if (this.pageable) {
                this.listPagingOptions = {
                    pageNumber: this.pageableQuery.pageNumber,
                    pageSize: this.pageableQuery.pageSize,
                    pageStep: 1,
                    totalCount: totalCount,
                    pageFirstItem: (this.pageableQuery.pageNumber - 1) * this.pageableQuery.pageSize + 1,
                    pageLastItem: Math.min((this.pageableQuery.pageNumber * this.pageableQuery.pageSize), totalCount)
                }

            }
        }
    }

    export class ServerQueryManipulator extends QueryManipulator {

        public constructor(
            $scope: ng.IScope,
            $q: ng.IQService,
            query: IQueryAction,
            private actionService: dg.actions.ActionService) {

            super($scope, $q, query);
        }

        protected getData() {
            return this.actionService.executeQuery(this.query);
        }
    }

    export class ClientQueryManipulator extends QueryManipulator {

        public getData() {
            let defered = this.$q.defer();
            defered.resolve(this.queryResult);
            return defered.promise;
        }

        public setResult(result: ListQueryResult<dg.domain.IDomainObject>) {
            this.queryResult = result;
        }
    }
}